import { render } from "./t-modal.vue?vue&type=template&id=0884bfc9&scoped=true"
import script from "./t-modal.vue?vue&type=script&lang=js"
export * from "./t-modal.vue?vue&type=script&lang=js"

import "./t-modal.vue?vue&type=style&index=0&id=0884bfc9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0884bfc9"]])

export default __exports__